module.exports = __webpack_public_path__ + "img/schedule2-completed.5d4f925a.png";